import { SVGProps, Ref, forwardRef } from 'react';

export const MinusOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path fillRule="evenodd" clipRule="evenodd" d="M20 12.9H4v-1.8h16z" fill="currentColor" />
        </g>
    </svg>
));
MinusOutlinedSize24Glyph.displayName = 'MinusOutlinedSize24Glyph';
